export default __webpack_public_path__ + "static/media/bogsneak.0f5552a0.png";